// Monatsraster für Dienstplan-Kalender (Wochen beginnen montags).
export function buildMonthGrid(year, month) {
  const firstDay = new Date(Date.UTC(year, month, 1));
  const daysInMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  const offset = (firstDay.getUTCDay() + 6) % 7; // 0 = Montag

  const cells = [];
  for (let i = 0; i < offset; i += 1) cells.push(null);
  for (let day = 1; day <= daysInMonth; day += 1) {
    const iso = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    cells.push({ day, iso });
  }
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));
  return weeks;
}

export const WOCHENTAGE_KURZ = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

export function monatsLabel(year, month) {
  return new Date(Date.UTC(year, month, 1)).toLocaleDateString('de-DE', { month: 'long', year: 'numeric', timeZone: 'UTC' });
}

export function todayIso() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

export function formatZeit(schicht) {
  if (schicht.zeit_von && schicht.zeit_bis) return `${schicht.zeit_von}–${schicht.zeit_bis} Uhr`;
  if (schicht.zeit_von) return `ab ${schicht.zeit_von} Uhr`;
  if (schicht.zeit_bis) return `bis ${schicht.zeit_bis} Uhr`;
  return '';
}
